import { render } from "./GeometryComponent.vue?vue&type=template&id=19023d2b"
import script from "./GeometryComponent.vue?vue&type=script&lang=js"
export * from "./GeometryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__